import React from 'react';
import { ThemeProvider } from 'styled-components';

import { miniBannnersInternetData } from '~/src/components/BlockInternet/constants';

import * as ST from './styled';

const MiniBannersInternet: React.FC = () => {
    return (
        <ST.MiniBannersInternetContainer>
            <ST.MiniBannersInternetBlock>
                {miniBannnersInternetData.map((elem) => (
                    <ThemeProvider theme={{ initialTypeIsRow: elem.initialTypeIsRow }} key={elem.id}>
                        <ST.ImgBlock background={elem.background}>
                            <ST.ImgContainer>
                                <ST.AbsoluteImgOne imgFirst={elem.absoluteImgOne} />
                                <ST.AbsoluteImgTwo imgSecond={elem.absoluteImgTwo} />
                                <ST.AbsoluteImgThree imgThird={elem.absoluteImgThree} />
                            </ST.ImgContainer>
                            <ST.TextBlock>
                                <ST.Title style={{ color: elem.color }}>
                                    {elem.title}
                                </ST.Title>
                                <ST.SubText style={{ color: elem.color }} dangerouslySetInnerHTML={{ __html: elem.subText }}/>
                            </ST.TextBlock>
                        </ST.ImgBlock>
                    </ThemeProvider>
                ))}
            </ST.MiniBannersInternetBlock>
        </ST.MiniBannersInternetContainer>
    );
};

export default MiniBannersInternet;
